import React from "react";

export const Bitumen = [
  <>
    <h4 className="slideTitle">Shell Bitumen Fresh Air</h4>
    <div className="slideContainer slide_solidColour">
      <ul className="shell_bullets_list">
        <li>
          <strong>Insight</strong>
          <br />
          Over 91% of the world’s population lives in places where air quality
          exceeds world health organisation (WHO) guideline limits.*<br/>
          <sup className="mt-2 d-block">
            *https://www.who.int/airpollution 
          </sup>
        </li>
        <li>
          <strong>Customer Pain Points</strong>
          <ul className="shell_bullets_list">
            <li>
              Stricter governmental regulations are putting pressure on asphalt
              manufacturers to improve working conditions and local air quality
              as well as to limit nuisance on communities close to their working
              sites.
            </li>
            <li>
              Asphalt manufacturers and road constructors need to consider
              changing the way they work.
            </li>
          </ul>
        </li>
        <li>
          <strong>
            <span className="red">Solution</span>: Shell Bitumen Fresh Air
          </strong>
          <br />
          Shell Bitumen FreshAir is a bitumen solution tested with road
          constructors and air quality experts that actively reduces the
          emission of specific gases and particulates during production and
          paving.
          <br />
          <br />
          Shell Bitumen FreshAir is our ready-to-use bitumen that can
          effectively reduce specific gases and particulate matter from asphalt
          mixtures by an average of 40% and therefore help reduce the impact of
          our industry on local air quality levels. 
        </li>
      </ul>
    </div>
  </>,
  <>
    <h4 class="slideTitle">Our customer value proposition</h4>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p>
          <strong>The Science Behind Shell Bitumen FreshAir</strong>
        </p>
        <p className="number">
          <span>1</span> An innovative, active additive bitumen technology is
          applied to conventional bitumen.
        </p>
        <p className="number">
          <span>2</span> Inhibiting components in the additive react directly
          with selective compounds (the source of specific gases, particulates
          and odour-releasing molecules) in bitumen.
        </p>
        <p className="number">
          <span>3</span> A chemical reaction occurs at a molecular level,
          minimizing formation of specific gases and particulates, and chances
          of them becoming airborne.
        </p>
      </div>
      <div className="colRight col50">
        <img src="images/conventionalBitumen.png" alt="" />
        <p>
          <strong>Conventional Bitumen</strong>
          <br />
          Release gases and particulates when heated
        </p>
        <img src="images/freshAirBitumen.png" alt="" />
        <p>
          <strong className="red">Shell Bitumen FreshAir</strong>
          <br />
          Inhibits and slows the release of gases and particulates when heated
        </p>
      </div>
    </div>
  </>,
  <>
    <h4 class="slideTitle">Our customer value proposition</h4>
    <div className="slideContainer slide_solidColour noGutters">
      <div className="colLeft col50 solidColourContainer">
        <p>
          Shell is the first major supplier of bitumen to tackle the issue of
          air quality during asphalt production and paving. Shell Bitumen
          FreshAir can help reduce the impact of road paving on air quality as
          well as neutralise bitumen odour.
        </p>
        <p>
          Shell Bitumen FreshAir makes no compromise on end quality. The
          additive leaves bitumen properties and asphalt mixture performance
          unchanged for both Shell penetration grade bitumen and polymer
          modified bitumen (Shell Cariphalte). Shell Bitumen FreshAir offers a
          cleaner, better way of working for every road development, from the
          standard to the best-performing.
        </p>
      </div>
      <div className="colRight col50 backgroundImage">
        <img
          src="images/bitumenBackground.jpg"
          width="100%"
          height="auto"
          alt=""
        />
      </div>
    </div>
  </>,
  <>
    <h4 class="slideTitle">Our customer value proposition</h4>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p class="statsIntro">
          <strong>Key benefits</strong>
        </p>
        <p></p>
        <ul className="shell_bullets_list">
          <li>
            <strong>Plant Owners</strong>
            <br />
            Prove themselves as responsible and cleaner operators
          </li>
          <li>
            <strong>Road Contractors</strong>
            <br />
            Differentiate themselves as a greener contractor in project tenders
          </li>
        </ul>
        <p><strong>Impact on Sustainability and Decarbonisation</strong></p>
        <p>
          Switching to Shell Bitumen FreshAir is estimated to have a similar
          impact:
        </p>
      </div>
      <div className="colRight col50 solidColourContainer stats">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">16 trees</span>
            <br />
            per kilometre of asphalt laid per year<sup>1</sup>
          </p>
          <p className="figureContainer">
            <span className="figure">40 cars</span>
            <br />
            per kilometre of asphalt laid per year<sup>1</sup>
          </p>
        </div>
        <p>
          <sup>
            1As compared with conventional bitumen. For full details, refer to
            Shell Bitumen FreshAir Technical Knowledge guide.
          </sup>
        </p>
      </div>
    </div>
  </>,
    <>
    <h4 class="slideTitle">Our customer value proposition</h4>
    <div className="slideContainer slide_solidColour noGutters">
      <div className="colLeft col50 solidColourContainer">
        <p>
          <strong>What Shell Bitumen FreshAir is designed for:</strong>
        </p>
        <ul className="shell_bullets_list">
            <li>Easy implementation as a ready-to-use solution</li>
            <li>Total bitumen solution (Penetration Grade and Polymer Modified Bitumen)</li>
            <li>Improved working conditions</li>
            <li>Reduced impact on local air quality</li>
            <li>Long-lasting bitumen odour neutralization (at least two weeks)</li>
        </ul>
      </div>
      <div className="colRight col50 backgroundImage">
        <img
          src="images/bitumenBackground.jpg"
          width="100%"
          height="auto"
          alt=""
        />
      </div>
    </div>
  </>,
];
